<template>
  <div>
    <div class="upload">
      <div class="upload_content">

            <span class="img_box" v-for="(src,index) in fileList" :key="index">
                <img :src="src.imgUrl" class="upload_img" :style="src.img" @click="deleteImage(index)"/>
            </span>
      </div>
      <div class="up_title">上传图片</div>
      <div class="van-uploader">
        <div class="van-uploader__wrapper">
          <div @click="chooseImage" class="van-uploader__upload">
            <van-icon class="van-icon van-icon-plus van-uploader__upload-icon" name="plus" />
            <input multiple="multiple" accept="image/*" class="van-uploader__input" type="flie">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { Uploader } from 'vant';
  import { Popup } from 'vant';
  import { Toast } from 'vant';
  import wx from 'weixin-js-sdk';
  import { Icon } from 'vant';
  import { Dialog } from 'vant';
  import { Image } from 'vant';
  import { Overlay } from 'vant';
  Vue.use(Overlay);
  Vue.use(Image);
  Vue.use(Icon);
  Vue.use(Toast);
  Vue.use(Popup);
  Vue.use(Uploader);





  export default{
    data() {//定义数据容器
      return {
        instrumentid:'',
        fileList: []
      }
      },
   created() {//加载初始数据
      window.app=this
     this.instrumentid = this.$route.params.id
     this.getImgData()
   },
   mounted() {//微信图片上传所需的配置文件
     this.axios.get('/weixin/wxJsSdkConfig',{
       params: {
         url : location.href.split('#')[0]
       }
     }).then((res)=>{
       wx.config({
         debug: false, // 开启调试模式,
         appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
         timestamp: res.data.timestamp, // 必填，生成签名的时间戳
         nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
         signature: res.data.signature,// 必填，签名，见附录1
         jsApiList: ['chooseImage','uploadImage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
       });
     }),
       wx.ready(function() {
         wx.checkJsApi({
           jsApiList : [ 'openWXDeviceLib', 'closeWXDeviceLib','chooseImage','uploadImage'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
           success : function(res) {
           }
         });
         wx.invoke('openWXDeviceLib', {
           'connType' : 'lan'

         }, function(res) {
         });

       });
   },





    methods: {
      //查询已经上传的图片
      getImgData() {
        this.axios.get('/weixin/getInstrumentimgs',{
          params: {
            instrumentid: this.instrumentid
          }
        })
          .then(res=>{
            for(let i = 0; i < res.data.length; i++) {
              this.fileList.push({ imgUrl: `/img/tupian/${res.data[i].instrumentimgurl}.png` })


            }
          })
      },

      //图片删除
      deleteImage(index){
       Dialog.confirm({
          title: '图片',
          message: '是否删除该图片',
        })
          .then(() => {
            this.axios.get('/weixin/deleteImg',{
              params: {
                imgUrl:this.fileList[index].imgUrl,
                instrumentid: this.instrumentid
              }
            })
              .then(res=>{
                Dialog.alert({
                  title: '图片',
                  message: '删除成功',
                }).then(() => {
                  // on close
                });
              this.fileList= undefined;
              this.fileList = new Array();
              this.getImgData()
            })

          })
          .catch(() => {

          })
      },

      //图片上传
      addImage(serverId) {

        const formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
        formData.append('file', serverId); //接口需要传的参数*/
        formData.append("instrumentid",this.instrumentid)

        if(this.fileList.length>8){
          alert("图片上传已到最大数量！");
        }else{
          this.axios.post('/weixin/instrumentImg3',formData
          )
            .then(res=>{
              Dialog.alert({
                title: '图片',
                message: '上传成功',
              }).then(() => {
                // on close
              });
              this.fileList= undefined;
              this.fileList = new Array();
              this.getImgData()
            })
        }
      },

      //图片大小限制
      onOversize(file) {
     //   console.log(file);
        Toast('文件大小不能超过 500kb');
      },


      //微信从相机或相册里面获取图片信息
      chooseImage(){//从相机或相册里面获取图片信息
      //  const  th=this;
        wx.chooseImage({

          count: 1, // 默认9
          sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success: function(res){
            wx.uploadImage({//图片上传到微信服务器
              localId: res.localIds.toString(), // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: function(res){
                 const serverId= res.serverId;

                window.app.addImage(serverId) // 返回图片的服务器端ID
              },
              fail: function (e) {
             //   console.log(e);
             //   alert(e);
              }
            })
          }
        });
      },




    },
  };
</script>


<style  scoped>
  .upload {
    padding: 30px;
  }

  .upload_content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .upload_content:after{
    content: '';
    width: 30%;
    border: 2px solid transparent;
  }
  .img_box {
    position: relative;
    display: inline-block;
    width:30%;
    height: 240px;
    background: #fff;
    border: 2px solid #ccc;
    margin-bottom: 44px;
    text-align: center;
    line-height: 300px;
  }
  .upload_img {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/UploadImg2.vue